import { render, staticRenderFns } from "./LayoutBanner.vue?vue&type=template&id=277520b2&scoped=true&lang=pug&"
import script from "./LayoutBanner.vue?vue&type=script&lang=js&"
export * from "./LayoutBanner.vue?vue&type=script&lang=js&"
import style0 from "./LayoutBanner.vue?vue&type=style&index=0&id=277520b2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277520b2",
  null
  
)

export default component.exports